import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import debounce from "lodash.debounce";

function AnalyticsListener() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const pagePath = pathname + search;

    const sendPageView = debounce(() => {
      ReactGA.send({
        hitType: "pageview",
        page: pagePath,
        title: document.title,
      });
      
      if (process.env.NODE_ENV === "development") {
        console.log(`[Analytics] Pageview sent: ${pagePath}`);
      }
    }, 500);

    sendPageView();

    return () => {
      sendPageView.cancel();
    };
  }, [pathname, search]);

  return null;
}

export default AnalyticsListener;
